import NewsCard from "@/components/feature/NewsCard";
import type { NewsItem } from "@/types/content";

interface LatestNewsProps {
  news: NewsItem[];
}

export default function LatestNews({ news }: LatestNewsProps) {
  return (
    <div className="flex flex-col gap-3">
      {news.map((item) => (
        <NewsCard key={item.id} item={item} horizontal />
      ))}
    </div>
  );
}